/**
 * 同意隐私协议弹窗
 */
import BaseModal from "..";
import Agree from "./agree";

const AgreeModal = {
  agree: null,

  show(data = {}) {
    this.agree = BaseModal.show({
      ...data,
      borderRadius: 12,
      closable: false,
      maskClosable: false,
      content: (
        <Agree {...data} onClose={() => this.hide()} />
      ),
    });
  },
  hide () {
    if (this.agree) {
      this.agree.destroy();
      this.agree = null;
    }
  }
};

export default AgreeModal;